import styled from 'styled-components'

export const ContainerConfig = styled.div`
  width: 25%;
  box-sizing: border-box;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: white;
  position: absolute;
  z-index: 2;
  left: 10px;
  top: 10px;
  border-radius: 10px;
`

export const PopupRemover = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-weight: 600;
  font-size: 12px;
`

export const PainelPropsGrid = styled.div`
  position: absolute;
  top: 5px;
  left: 5px;
  width: 300px;
  background: #fff;
  z-index: 9999;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  opacity: 0;
  transform: translateY(50px);
  animation: fade 1s forwards;
  animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
  will-change: transform;
  overflow: hidden;
  transition: 0.2s;

  :is([data-shrink='true']) {
    transition: 0.5s;
    width: 200px;
    height: 70px;
  }

  @keyframes fade {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }

  div.PainelProps__info {
    display: flex;
    gap: 20px;
  }
`

export const AbasGrid = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  border-bottom: 2px dashed #d9d9d9;
  position: relative;
  padding-bottom: 5px;

  .aba__pontos {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 5px;
    width: 50%;

    span {
      font-size: 13px;
      color: black;
    }
  }

  .aba__ordenacao {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 5px;
    width: 50%;

    span {
      font-size: 13px;
      color: black;
    }
  }

  .aba__map {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 5px;
    width: 50%;

    span {
      font-size: 13px;
      color: black;
    }
  }

  .abas__icones {
    color: black;
    font-size: 15;
  }

  .aba__map:is([data-open='Mapa']) {
    transition: 1.3s;
    background-color: #5da57d;

    .abas__icones {
      color: white;
    }

    span {
      color: white;
    }
  }

  .aba__pontos:is([data-open='Pontos']) {
    background-color: #5da57d;
    transition: 1.2s;

    .abas__icones {
      color: white;
    }

    span {
      color: white;
    }
  }

  .aba__ordenacao:is([data-open='Ordenacao']) {
    background-color: #5da57d;
    transition: 1.2s;

    .abas__icones {
      color: white;
    }

    span {
      color: white;
    }
  }

  .indicador {
    width: 30%;
    background-color: #5da57d;
    height: 2px;
    border-radius: 10px;
    position: absolute;
  }

  .indicador:is([data-open='Pontos']) {
    transform: translate(115%);
    transition: 0.5s;
  }

  .indicador:is([data-open='Ordenacao']) {
    transform: translate(227%);
    transition: 0.5s;
  }

  .indicador:is([data-open='Mapa']) {
    transform: translate(5%);
    transition: 0.5s;
  }

  .aba__map:is([data-mostrar='true']) {
    opacity: 0;
  }

  .indicador:is([data-mostrar='true']) {
    opacity: 0;
  }

  .aba__map:is([data-mostrar='false']) {
    opacity: 1;
  }

  .indicador:is([data-mostrar='false']) {
    opacity: 1;
  }
`

export const OrdenacaoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  .circle {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: red;
    border: 2px solid black;

    span {
      font-size: 10px;
    }
  }

  .linha {
    height: 25px;
    border: 2px dashed red; /* Cor verdinha pra ficar simpática */
    border-radius: 8px;
    margin-left: 5px;
  }
`
export const ModalBaixar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const HeaderInfo = styled.div`
width: 100%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;
box-sizing: border-box;
padding-left: 5px;
padding-right: 5px;

 div {
  display: flex;
  gap: 3px;

  label{
    font-size: 13px;
    font-weight: bold;
  }

  p {
    font-size: 13px;
  }
 }
`